import React from 'react'
import styled from 'styled-components'

// Vaihe-esitys: numeroympyrät viivalla, jokaisen alla lyhyt nimi aina näkyvissä.

const TimelineWrapper = styled.ol`
	display: flex;
	list-style: none;
	margin: 0 0 40px;
	padding: 0;
`

const TimelineItem = styled.li`
	position: relative;
	flex: 1 1 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 0;
	&:not(:last-child)::after {
		content: '';
		position: absolute;
		top: 17px;
		left: calc(50% + 24px);
		right: calc(-50% + 24px);
		height: 3px;
		border-radius: 2px;
		background: ${props => props.theme.lineColor};
	}
	&.visited:not(:last-child)::after {
		background: ${props => props.theme.primaryColor};
	}
`

const TimelineButton = styled.button`
	width: 36px;
	height: 36px;
	border-radius: 50%;
	border: 2px solid ${props => props.theme.lineStrongColor};
	background: #fff;
	color: ${props => props.theme.mutedColor};
	font-family: inherit;
	font-size: 16px;
	font-weight: 700;
	line-height: 1;
	cursor: pointer;
	padding: 0;
	transition: all 0.15s ease;
	.visited & {
		background: ${props => props.theme.primaryColor};
		border-color: ${props => props.theme.primaryColor};
		color: #fff;
	}
	&:disabled {
		cursor: default;
		opacity: 0.55;
	}
	.current & {
		background: ${props => props.theme.navyColor};
		border-color: ${props => props.theme.navyColor};
		color: #fff;
		box-shadow: 0 0 0 4px rgba(11, 46, 77, 0.15);
	}
`

const TimelineTitle = styled.span`
	margin-top: 8px;
	font-size: 13px;
	line-height: 1.25;
	text-align: center;
	color: ${props => props.theme.mutedColor};
	padding: 0 4px;
	.current & {
		color: ${props => props.theme.navyColor};
		font-weight: 600;
	}
`

const Timeline = ({ page, totalPages, moveTo, pages, reachable = totalPages - 1 }) => {
	const items = []
	for (let i = 0; i < totalPages; i++) {
		const classes = []
		if (i < page) classes.push('visited')
		if (i === page) classes.push('current')
		items.push(
			<TimelineItem key={i} className={classes.join(' ')}>
				<TimelineButton
					type="button"
					onClick={() => moveTo(i)}
					disabled={i > reachable}
					aria-current={i === page ? 'step' : undefined}
					aria-label={`Vaihe ${i + 1}: ${pages[i].short || pages[i].title}`}
				>
					{i + 1}
				</TimelineButton>
				<TimelineTitle>{pages[i].short || pages[i].title}</TimelineTitle>
			</TimelineItem>,
		)
	}
	return <TimelineWrapper>{items}</TimelineWrapper>
}

export default Timeline
